import FanLivePage from "./FanLivePage";

export default FanLivePage;
